<p-tieredMenu [popup]="true" [model]="menuItems" styleClass="tiered-menu" (mouseleave)="closeFabMenu($event)"></p-tieredMenu>

<button id="fab" pButton pRipple icon="pi pi-plus" class="p-button-rounded p-button-outlined" [ngClass]="{ 'active': isActive }"
	(mouseover)="onFabMouseover($event)">
</button>

<ng-template #draftPickHeaderTemplate>
	<div class="p-d-flex p-ai-center w-100">
		<span class="p-dialog-title">{{proposedTemplate!.name}}</span>
		<span class="fa fa-question-circle clickable p-ml-1" title="More Info" (click)="infoPanel.show($event)"></span>
	</div>
	<p-overlayPanel #infoPanel appendTo="body">
		<div style="max-width: 700px">
			When draft notes exist for the template you have selected, this page allows you to see those drafts along with
			any key values, the date and time of the draft, and the co-creators that can work on the draft so that you
			can easily get back to working on prior drafts and not forget about them.
			Drafts for inspection type templates are automatically created and saved for you, as you begin to work on those notes.
			<br><br>
			If you want to start working on a new note, use the + New Note button.
			<br><br>
			If you want continue editing a prior draft, use its Edit button.
			<br><br>
			If see a draft or drafts that you no longer need and do not intend to ever publish, you can delete them here, using the respective Delete buttons.
			<br><br>
			If you decide you don't want to start a new note nor continue editing a draft note, use the [x] to dismiss this prompt.
			<br><br>
			<a helpLink="draft-chooser-on-new-inspection-note">See help for more details</a>
		</div>
	</p-overlayPanel>
</ng-template>

<ng-template #draftPickTemplate>
	<div class="p-d-flex p-flex-column">
		<div class="p-d-flex p-jc-center p-ai-center p-mb-1">
			<button pButton pRipple class="p-button-rounded" label="New Note" icon="pi pi-plus" (click)="navigateToNote(proposedTemplate!)"></button>
		</div>
		<div>
			<ng-container (container)="createDraftContainer($event)"></ng-container>
		</div>
	</div>
</ng-template>